var React = require('react');

function Confetti (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"confetti-2","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd"},React.createElement("polygon",{"id":"Path-70","fill":"#F47643","points":"7 18 7.85714286 11.5294118 12.7142857 7 17 10.5588235 12.7142857 15.4117647 11.2857143 18"})));
}

Confetti.defaultProps = {"width":"24px","height":"24px","viewBox":"0 0 24 24","version":"1.1"};

module.exports = Confetti;

Confetti.default = Confetti;
